import jwtAuthAxios from "./auth/jwtAuth";

const superadminServices = {};

superadminServices.getCompanies = async (params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/companies${params}`);
  return data;
};

superadminServices.getUsers = async (params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/users${params}`);
  return data;
};

superadminServices.getUser = async (id) => {
  const { data } = await jwtAuthAxios.get(`/superadmin/users/${id}`);
  return data;
};

superadminServices.getUsersEditOptions = async () => {
  const { data } = await jwtAuthAxios.get('/superadmin/users/edit_options');
  return data;
};

superadminServices.updateUser = async (id, body) => {
  const { data } = await jwtAuthAxios.put(`/superadmin/users/${id}`, body);
  return data;
};

superadminServices.archiveUser = async (id) => {
  const { data } = await jwtAuthAxios.post(`/superadmin/users/${id}/archive`);
  return data;
};

superadminServices.restoreUser = async (id) => {
  const { data } = await jwtAuthAxios.post(`/superadmin/users/${id}/restore`);
  return data;
};

superadminServices.createCompany = async (body) => {
  const { data } = await jwtAuthAxios.post('/superadmin/companies', body);
  return data;
};

superadminServices.updateCompany = async (id, body) => {
  const { data } = await jwtAuthAxios.put(`/superadmin/companies/${id}`, body);
  return data;
};

superadminServices.deleteCompany = async (id, mode) => {
  const { data } = await jwtAuthAxios.delete(`/superadmin/companies/${id}?mode=${mode}`);
  return data;
};

superadminServices.getCompanyPluginAvailabilities = async (companyId) => {
  const { data } = await jwtAuthAxios.get(`/superadmin/companies/${companyId}/plugin_availabilities`);
  return data;
};

superadminServices.toggleCompanyPluginAvailability = async (companyId, pluginId) => {
  const { data } = await jwtAuthAxios.post(`/superadmin/companies/${companyId}/plugin_availabilities/${pluginId}/toggle`);
  return data;
};

superadminServices.getDevices = async (params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/devices${params}`);
  return data;
};

superadminServices.getDevice = async (id, params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/devices/${id}${params}`);
  return data;
};

// Alta de un equipo físico con sus puntos (vault: 03 Producto/Modelo de equipos y puntos).
superadminServices.createPhysicalDevice = async (body) => {
  const { data } = await jwtAuthAxios.post('/superadmin/physical_devices', body);
  return data;
};

// Equipos de Xpit AI Vision: pendientes de adopción y adoptados (vault: 07 Proyectos/Xpit AI Vision).
superadminServices.getVisionDevices = async (state = 'pending') => {
  const { data } = await jwtAuthAxios.get(`/superadmin/vision_devices?state=${state}`);
  return data;
};

superadminServices.getVisionDevice = async (id) => {
  const { data } = await jwtAuthAxios.get(`/superadmin/vision_devices/${id}`);
  return data;
};

// Por selección ({ id }) o por el código que muestra el equipo ({ adoption_code }), con store_id y name.
superadminServices.adoptVisionDevice = async (body) => {
  const { data } = await jwtAuthAxios.post('/superadmin/vision_devices/adopt', body);
  return data;
};

superadminServices.getVisionDeviceUiPassword = async (id) => {
  const { data } = await jwtAuthAxios.get(`/superadmin/vision_devices/${id}/ui_password`);
  return data;
};

superadminServices.rotateVisionDeviceUiPassword = async (id) => {
  const { data } = await jwtAuthAxios.post(`/superadmin/vision_devices/${id}/rotate_ui_password`);
  return data;
};

superadminServices.pushVisionDeviceSettings = async (id) => {
  const { data } = await jwtAuthAxios.post(`/superadmin/vision_devices/${id}/push_settings`);
  return data;
};

superadminServices.createDevice = async (body, params = "") => {
  const { data } = await jwtAuthAxios.post(`/superadmin/devices${params}`, body);
  return data;
};

superadminServices.updateDevice = async (id, body, params = "") => {
  const { data } = await jwtAuthAxios.put(`/superadmin/devices/${id}${params}`, body);
  return data;
};

superadminServices.deleteDevice = async (id) => {
  const { data } = await jwtAuthAxios.delete(`/superadmin/devices/${id}`);
  return data;
};

superadminServices.getDemoRequests = async (params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/demo_requests${params}`);
  return data;
};

superadminServices.getDemoRequestLeads = async (params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/demo_requests/leads${params}`);
  return data;
};

superadminServices.stopDemoRequest = async (id) => {
  const { data } = await jwtAuthAxios.post(`/superadmin/demo_requests/${id}/stop`);
  return data;
};

superadminServices.getDeviceEditOptions = async ({ companyId = null, deviceId = null } = {}) => {
  const parts = [];
  if (companyId) parts.push(`company_id=${companyId}`);
  if (deviceId) parts.push(`device_id=${deviceId}`);
  const query = parts.length ? `?${parts.join('&')}` : '';
  const { data } = await jwtAuthAxios.get(`/superadmin/devices/edit_options${query}`);
  return data;
};

superadminServices.getDeviceTypes = async (params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/device_types${params}`);
  return data;
};

superadminServices.createDeviceType = async (body) => {
  const { data } = await jwtAuthAxios.post('/superadmin/device_types', body);
  return data;
};

superadminServices.updateDeviceType = async (id, body) => {
  const { data } = await jwtAuthAxios.put(`/superadmin/device_types/${id}`, body);
  return data;
};

superadminServices.deleteDeviceType = async (id) => {
  const { data } = await jwtAuthAxios.delete(`/superadmin/device_types/${id}`);
  return data;
};

superadminServices.getMeasurementTypes = async (params = "") => {
  const { data } = await jwtAuthAxios.get(`/superadmin/measurement_types${params}`);
  return data;
};

superadminServices.createMeasurementType = async (body) => {
  const { data } = await jwtAuthAxios.post('/superadmin/measurement_types', body);
  return data;
};

superadminServices.updateMeasurementType = async (id, body) => {
  const { data } = await jwtAuthAxios.put(`/superadmin/measurement_types/${id}`, body);
  return data;
};

superadminServices.deleteMeasurementType = async (id) => {
  const { data } = await jwtAuthAxios.delete(`/superadmin/measurement_types/${id}`);
  return data;
};

export default superadminServices;
